import React from 'react';
import ROUTES from '../../../routes';
import {Link, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {resetHeartCondition, saveHeartCondition} from '../../../redux/actions/heartCondition';
import {GLOSSARY_KEYS, HEART_CONDITIONS} from '../appConstants';
import {unlockNavItem} from '../../../redux/actions/unlockedNavItems';
import {Tooltip} from '../../components/common/tooltip';
import {useForm} from 'react-hook-form';

const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const heartCondition = useSelector(state => state.heartCondition);
  const {register, handleSubmit, formState: {errors}} = useForm({
    defaultValues: heartCondition
  });

  const onSubmit = data => {
    dispatch(saveHeartCondition(data));
    dispatch(unlockNavItem([ROUTES.HEALTH_FACTORS]));
    navigate(ROUTES.HEALTH_FACTORS);
  };

  const handleReset = () => {
    dispatch(resetHeartCondition());
  };

  return <>
    <section className='full-viewport-height'>
      <div className='grid-container'>
        <form onSubmit={handleSubmit(onSubmit)}>

          <div className='form-card'>
            <h1>
              Your Heart Condition:
            </h1>
            <p className='lead required-field'>
              From the following two options below, please select the heart condition that best
              describes what you are experiencing.
            </p>
            <div className='grid-x'>
              <div className='cell'>
                <div className='flex-align'>
                  <input
                    id='yes_for_heartConditions'
                    name={HEART_CONDITIONS.HEART_CONDITION}
                    type='radio'
                    value={HEART_CONDITIONS.HEART_ATTACK}
                    {...register(HEART_CONDITIONS.HEART_CONDITION, {required: true})}
                  />
                  <label
                    className='margin-0 padding-1 width-100'
                    htmlFor='yes_for_heartConditions'>
                    Heart Attack (non-ST elevation myocardial infarction, or unstable <Tooltip
                      id={GLOSSARY_KEYS.ANGINA}
                      title='angina'/>)
                  </label>
                </div>
              </div>
              <div className='cell'>
                <div className='flex-align'>
                  <input
                    id='no_for_heartConditions'
                    name={HEART_CONDITIONS.HEART_CONDITION}
                    type='radio'
                    value={HEART_CONDITIONS.STABLE_CORONARY_HEART_DISEASE}
                    {...register(HEART_CONDITIONS.HEART_CONDITION, {required: true})}
                  />
                  <label
                    className='margin-0 padding-1 width-100'
                    htmlFor='no_for_heartConditions'>
                    Stable Coronary Heart Disease (stable <Tooltip
                      id={GLOSSARY_KEYS.ANGINA}
                      title='angina'/>&nbsp;)
                  </label>
                </div>
              </div>
            </div>
            {errors.heartCondition && <span className='error'>This field is required</span>}
          </div>
          <div className='form-card'>
            <h1>
              Select Data Source for Your Personalized Risk/Benefit Calculations:
            </h1>
            <p className='lead required-field'>
              From the following two options below, please select the one that would best suit the source of risk
              /benefit
              information you would like to use.
            </p>
            <div className='grid-x'>
              <div className='cell'>
                <div className='flex-align'>
                  <input
                    id='yes_for_dataSourceProvince'
                    name={HEART_CONDITIONS.DATA_SOURCE_PROVINCE}
                    type='radio'
                    value={HEART_CONDITIONS.ALBERTA_GENERAL_POPULATION}
                    {...register(HEART_CONDITIONS.DATA_SOURCE_PROVINCE, {required: true})}
                  />
                  <label
                    className='margin-0 padding-1 width-100'
                    htmlFor='yes_for_dataSourceProvince'>
                    General population
                  </label>
                </div>
              </div>
              <div className='cell'>
                <div className='flex-align'>
                  <input
                    id='no_for_dataSourceProvince'
                    name={HEART_CONDITIONS.DATA_SOURCE_PROVINCE}
                    type='radio'
                    value={HEART_CONDITIONS.BC_ONLY_PEOPLE_REFERRED_TO_A_NEPHROLOGIST}
                    {...register(HEART_CONDITIONS.DATA_SOURCE_PROVINCE, {required: true})}
                  />
                  <label
                    className='margin-0 padding-1 width-100'
                    htmlFor='no_for_dataSourceProvince'>
                    Only people referred to a nephrologist
                  </label>
                </div>
              </div>
            </div>
            {errors.dataSourceProvince &&
              <span className='error'>This field is required</span>}
          </div>
          <div className='grid-x small-up-4 align-spaced text-center margin-top-3'>
            <div className='cell'>
              <Link
                className='hollow secondary button large rounded padding-horizontal-2'
                to={ROUTES.MY_PRIORITIES}>Back</Link>
            </div>
            <div className='cell text-center'>
              <input
                className='alert button large hollow rounded padding-horizontal-2'
                onClick={() => handleReset()}
                type='reset'
                value='Reset Choices'
              />
            </div>
            <div className='cell'>
              <input
                className='button large primary rounded padding-horizontal-2'
                type='submit'
                value='Next'/>
            </div>
          </div>
        </form>
      </div>
    </section>
  </>;
};

export default Index;
